<template>
  <v-dialog v-model="dialog" max-width="600px" persistent>
    <nv-form
      :errors="formErrors"
      :save-disabled="!isValid"
      :loading="loading"
      save-text="Merge"
      title="Merge Parent"
      @cancel="onClose"
      @nv-submit="formSubmit"
    >
      <v-card-text>
        <p class="text-h6">Select parents to merge with {{ sourceParent.name }}</p>
        <div
          v-for="(parent, index) in targetParents"
          :key="`parent-${index}-${parent.id}`"
          class="d-flex align-center mb-2"
        >
          <span class="flex-grow-1">
            <tree-search
              v-model="parent.id"
              mode="parent"
              :rules="rules.tree"
              :country-code="countryCode"
            />
            <div v-if="parent.error" class="error--text">{{ parent.error }}</div>
          </span>
          <v-btn v-if="targetParents.length > 1" icon color="primary" @click="removeParent(index)">
            <v-icon>mdi-delete</v-icon>
          </v-btn>
          <v-btn v-if="index === targetParents.length - 1" icon color="primary" @click="addParent">
            <v-icon>mdi-plus</v-icon>
          </v-btn>
        </div>
      </v-card-text>
      <v-card-actions>
        <!-- <v-spacer></v-spacer>
                <v-btn color="red" text @click="close">Cancel</v-btn>
                <v-btn color="primary" @click="merge" :disabled="!isValid">Merge</v-btn> -->
      </v-card-actions>
    </nv-form>
  </v-dialog>
</template>

<script>
import HTTP from '@/api/owl';
import Rules from 'bsm-validation-rules';
import { FormMixin } from '@nielsen-media/ui-toolkit-vue-api';
import TreeSearch from '@/components/mv/TreeSearch';
import { getCountryByValue } from '@/helpers/filters';

const rules = { tree: [Rules.presence()] };

export default {
  name: 'MergeParentDialog',
  components: {
    TreeSearch,
  },
  mixins: [FormMixin],
  props: {
    value: Boolean,
    treeId: {
      type: Number,
      required: true,
    },
    sourceParent: {
      type: Object,
      default: null,
    },
    countryCode: {
      type: String,
      default: '*',
    },
  },
  data() {
    return {
      rules,
      targetParents: [{ id: null, error: null }],
      availableParents: [],
      isValid: true,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  watch: {
    targetParents: {
      deep: true,
      handler(parents) {
        let hasError = false;
        parents.forEach(parent => {
          if (parent.id === this.treeId) {
            parent.error = 'Source tree id cannot be selected';
            hasError = true;
          } else {
            parent.error = null;
          }
        });

        // Check if all parents have valid IDs
        const allHaveIds = parents.every(parent => parent.id !== null);
        this.isValid = !hasError && allHaveIds;
      },
    },
  },
  methods: {
    addParent() {
      this.targetParents.push({ id: null, error: null });
    },
    removeParent(index) {
      this.targetParents.splice(index, 1);
    },
    formSave() {
      const targetIds = this.targetParents.map(parent => parent.id);
      HTTP.post(`/parents/${this.treeId}/merge`, {
        parent_ids: targetIds,
        country_code: getCountryByValue(this.countryCode),
      })
        .then(({ data }) => {
          const dataArray = Array.isArray(data) ? data : [];
          if (dataArray.length === 0) {
            this.$flash('error', 'parents already merged');
            return;
          }
          const parent_names = dataArray.join(', ');
          this.$flash(
            'success',
            `Parent${dataArray.length > 1 ? 's' : ''} ${parent_names} ${
              dataArray.length > 1 ? 'have' : 'has'
            } been successfully merged`,
          );
        })
        .catch(error => {
          this.$flash('error', 'Failed to merge parents');
          console.error(error);
        })
        .finally(() => {
          this.onClose();
        });
    },
    onClose() {
      this.dialog = false;
      this.targetParents = [{ id: null, error: null }];
      this.formCancel();
    },
  },
};
</script>
